const routes = [
    {
        path: '/pages/daySignin/daySignin',
        name: 'daySignin',
        meta: {
            title: "每日签到",
            keepAlive: false,
            isLogin: true
        },
        component: () => import('../pages/daySignin/daySignin.vue')
    },
]
export default routes